import { render, staticRenderFns } from "./TechnicalSupport.vue?vue&type=template&id=49f82f13&scoped=true"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f82f13",
  null
  
)

export default component.exports